import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BarGraphConfig, BarGraphData } from './bar-graph/bar-graph.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'horizontal-bar-graph',
  templateUrl: './horizontal-bar-graph.component.html',
  styleUrls: ['./horizontal-bar-graph.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HorizontalBarGraphComponent implements OnInit {
  @Input() config: BarGraphConfig;
  @Input() data: BarGraphData[];

  ngOnInit(): void {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config as BarGraphConfig;
    this.data = data as BarGraphData[];
  }
}
